import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import Layout from "../components/Layout";
import { useAuth } from "../contexts/AuthContext";
import { Sparkles, Crown, Check } from "lucide-react";

const PlanCard = ({ id, plan, onChoose, current }) => {
  const [chosen, setChosen] = useState(0);
  const isCreator = id === "creator";
  return (
    <div className={`editorial-card p-8 flex flex-col ${isCreator ? "ring-1 ring-[var(--copper)]/40" : ""}`}>
      <div className="flex items-center gap-2 mb-1">
        {isCreator ? <Crown className="h-4 w-4 text-[var(--copper)]" /> : <Sparkles className="h-4 w-4 text-[var(--magenta)]" />}
        <span className="font-meta" style={{ color: isCreator ? "var(--copper)" : "var(--magenta)" }}>
          {plan.name}
        </span>
      </div>
      <h3 className="font-fraunces italic text-3xl text-[var(--cream)] leading-tight mb-2">
        {plan.tagline}
      </h3>

      <ul className="space-y-2.5 my-6 flex-1">
        {plan.perks.map((p) => (
          <li key={p} className="flex items-start gap-3 font-manrope text-sm text-[var(--cream)]/85">
            <Check className="h-4 w-4 mt-0.5 shrink-0" style={{ color: isCreator ? "var(--copper)" : "var(--magenta)" }} />
            <span>{p}</span>
          </li>
        ))}
      </ul>

      <div className="space-y-2 mb-6">
        {plan.options.map((opt, i) => (
          <button key={i} type="button" onClick={()=>setChosen(i)}
            className={`w-full flex items-center justify-between px-4 py-3 border transition-colors ${
              chosen === i
                ? `border-[${isCreator ? "var(--copper)" : "var(--magenta)"}] bg-white/5`
                : "border-white/10 hover:border-white/30"
            }`}
            style={chosen === i ? { borderColor: isCreator ? "var(--copper)" : "var(--magenta)" } : {}}
            data-testid={`plan-${id}-opt-${i}`}>
            <span className="font-manrope text-sm text-[var(--cream)]">{opt.label}</span>
            <span className="flex items-center gap-3">
              {opt.save && <span className="font-meta" style={{ color: isCreator ? "var(--copper)" : "var(--magenta)" }}>spar {opt.save}</span>}
              <span className="font-fraunces italic text-2xl text-[var(--cream)]">{opt.price_nok},-</span>
            </span>
          </button>
        ))}
      </div>

      <button onClick={()=>onChoose(id, chosen)}
              className={isCreator ? "btn-magenta" : "btn-magenta"}
              style={isCreator ? { background: "var(--copper)" } : {}}
              data-testid={`choose-${id}`}>
        {current === id ? "Du har denne planen" : `Velg ${plan.name}`}
      </button>
    </div>
  );
};

export default function Oppgrader() {
  const { user } = useAuth();
  const [plans, setPlans]   = useState(null);
  const [me, setMe]         = useState(null);
  const [msg, setMsg]       = useState("");
  const [error, setError]   = useState("");

  useEffect(() => {
    api.get("/billing/plans").then((r)=>setPlans(r.data));
    if (user && user !== false) api.get("/billing/me").then((r)=>setMe(r.data)).catch(()=>{});
  }, [user]);

  const choose = async (plan, optionIndex) => {
    setMsg(""); setError("");
    if (!user || user === false) { window.location.href = "/login"; return; }
    try {
      const { data } = await api.post(`/billing/checkout?plan=${plan}&option_index=${optionIndex}`);
      setMsg(data.message || "Sjekkout starter snart…");
    } catch (e) { setError(formatApiError(e)); }
  };

  return (
    <Layout withSidebar={false}>
      <div className="text-center max-w-2xl mx-auto mb-14">
        <div className="font-meta mb-3">Oppgrader</div>
        <h1 className="font-fraunces italic text-5xl sm:text-6xl text-[var(--cream)] leading-tight mb-4">
          Få mer ut av Norsk Erotikk.
        </h1>
        <p className="font-manrope text-base text-[var(--cream-soft)] leading-relaxed">
          To planer – én for aktive medlemmer, en for innholdsskapere som vil tjene på det de deler.
          Betaling gjennom Vipps og kort kommer snart.
        </p>
      </div>

      {plans && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-5xl mx-auto">
          <PlanCard id="plus"    plan={plans.plus}    onChoose={choose} current={me?.tier} />
          <PlanCard id="creator" plan={plans.creator} onChoose={choose} current={me?.tier} />
        </div>
      )}

      {msg && (
        <div className="max-w-3xl mx-auto mt-8 editorial-card p-5 text-center">
          <div className="font-fraunces italic text-lg text-[var(--magenta)]">{msg}</div>
        </div>
      )}
      {error && <div className="max-w-3xl mx-auto mt-8 text-center text-[var(--cream)] font-medium border-l-2 border-[var(--magenta)] pl-3">{error}</div>}

      <div className="max-w-3xl mx-auto mt-14 text-center">
        <div className="font-meta mb-2">Spørsmål om Creator-statusen?</div>
        <p className="font-manrope text-sm text-[var(--cream-soft)] leading-relaxed">
          Creator er for deg som vil bruke Norsk Erotikk som plattform for å fremme dine andre kanaler – OnlyFans, Fansly, sosiale medier eller egen nettbutikk.
          Når du blir Creator, får du verifisert merke, eksterne lenker på profilen din, og statistikk over visninger og klikk.
        </p>
      </div>
    </Layout>
  );
}
